import * as React from "react";
import Box from "../box";
import Stack from "../stack";
import Icon from "../icon";
import Text from "../text";
import { formatNumeric } from "../../helpers/number";
import type { StarTextProps } from "./star-text.types";

function StarText(props: StarTextProps) {
  return (
    <Box
      attributes={{
        ...props.attributes,
        onClick: () => props.onClick?.(),
      }}
      className={props.className}
    >
      <Stack
        attributes={{
          alignItems: "center",
        }}
      >
        {!!props.label ? (
          <Text
            color="$textSecondary"
            fontSize={props.size === "md" ? "$sm" : "$xl"}
            attributes={{
              marginRight: "$3",
            }}
          >
            {props.label}
          </Text>
        ) : null}
        <Text
          fontWeight="$semibold"
          fontSize={props.size === "md" ? "$sm" : "$xl"}
          attributes={{
            marginRight: "$3",
          }}
        >{`${formatNumeric(props.value, 2)} ${props.tokenName}`}</Text>
        {!props.iconSrc && props.showTokenIcon ? (
          <Icon
            name="stargazePixel"
            size="$md"
            attributes={{
              borderRadius: "$full",
              backgroundColor: "$black",
            }}
          />
        ) : null}
        {typeof props.iconSrc === "string" && props.showTokenIcon ? (
          <Box
            width="$8"
            height="$8"
            as="img"
            borderRadius="$full"
            backgroundColor="$gray300"
            attributes={{
              src: props.iconSrc,
              alt: "nft token icon",
            }}
          />
        ) : null}
      </Stack>
    </Box>
  );
}

StarText.defaultProps = { size: "md", tokenName: "STARS", showTokenIcon: true };

export default StarText;
